import React, { useState } from 'react';
import './CreaTuEventoPage.css';
import { useNavigate } from 'react-router-dom';

function CreaTuEventoPage() {
  const [formData, setFormData] = useState({
    nombreOrganizador: '',
    telefono: '',
    email: '',
    nombreEvento: '',
    ciudad: '',
    modalidad: '',
    categoria: '',
    fecha: '',
    direccion: '',
    descripcion: '',
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch(`${process.env.REACT_APP_API_URL}/api/events/enviarEvento`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    navigate('/gracias');
  };

  return (
    <div className="crea-tu-evento-container">
      <form className="form-container" onSubmit={handleSubmit}>
        <h2>¿Quieres vender tu evento con nosotros?</h2>
        <p>Ingresa la información de tu evento y nuestro equipo se contactará contigo.</p>
        <input name="nombreOrganizador" onChange={handleChange} placeholder="Nombre del organizador" />
        <input name="telefono" onChange={handleChange} placeholder="Teléfono del organizador" />
        <input name="email" type="email" onChange={handleChange} placeholder="Email" />
        <input name="nombreEvento" onChange={handleChange} placeholder="Nombre del evento" />
        <input name="ciudad" onChange={handleChange} placeholder="Ciudad del evento" />
        <select name="modalidad" onChange={handleChange}>
          <option value="">Modalidad del evento...</option>
          <option>Presencial</option>
          <option>Virtual</option>
        </select>
        <label className="category-title">Categoría del evento:</label>
        <div className="category">
        <div className="category-options">
          {["Concierto", "Festival", "Teatro", "Cursos", "Otro"].map((cat) => (
            <label key={cat} className="category-radio">
              <input type="radio" name="categoria" value={cat} onChange={handleChange} />
              {cat}
            </label>
          ))}
        </div>
      </div>
        Fecha Evento: <input name="fecha" type="date" onChange={handleChange} />
        <input name="direccion" onChange={handleChange} placeholder="Dirección del evento" />
        <textarea name="descripcion" onChange={handleChange} placeholder="Descripción del evento"></textarea>
        <button type="submit">Crea tu Evento</button>
      </form>
      <div className="image-container">
        <img src="/images/eventimage.jpg" alt="Event background" />
      </div>
    </div>
  );
}

export default CreaTuEventoPage;
